import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

export const LabelStyled = styled.label`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      position: relative;
      display: ${mediumUp ? 'inline-block' : 'block'};
      padding-right: ${mediumUp ? rem(10) : 0};
      text-align: left;
    `;
  }}
`;

export const LabelTextStyled = styled.span`
  ${({ theme }) => {
    return css`
      display: block;
      position: relative;
      padding-bottom: ${rem(4)};
      font-size: ${rem(14)};
      line-height: ${rem(16)};
      font-weight: 400;
      color: ${theme.colors.neutral.grayDark2}; /** note: once Module is using TextField Components, remove this label style */
    `;
  }}
`;

export const InputStyled = styled.input`
    ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      width: 100%;
      min-width: ${rem(220)};
      text-overflow: ellipsis;
      height: ${rem(56)};
      border: ${rem(1)} solid ${theme.colors.neutral.gray};
      color: ${theme.colors.neutral.grayDark2}; /** note: once Module is using TextField Components, remove this label style */
      font-weight: 400;
      padding-left: ${rem(15)};
      margin-bottom: ${mediumUp ? 0 : rem(20)};
      border-radius: ${rem(2)};
    `;
  }}
`;
